import { namespace } from 'vuex-class';
import { ICreateResourceState } from '@/content-library/create-resource/store/create-resource.types';

export const CreateResource = namespace('contentLibrary/createResource');

export const state: ICreateResourceState = {
  loaded: false,
  loading: false,
  saving: false,
  draft: null,
  savedResource: null,
};

export enum ECreateResourceAction {
  UpdateDraft = 'updateDraft',
  Create = 'create',
  CreateSuccess = 'createSuccess',
  CreateFailed = 'createFailed',
  Update = 'update',
  UpdateSuccess = 'updateSuccess',
  UpdateFailed = 'updateFailed',
  ResetState = 'resetState',
  SetLoadingFlags = 'setLoadingFlags',
}

export enum ECreateResourceMutation {
  SetDraft = 'setDraft',
  SetSavedResource = 'setSavedResource',
  SetLoading = 'setLoading',
  SetLoaded = 'setLoaded',
  SetSaving = 'setSaving',
  SetState = 'setState',
}
